import { Box, HStack } from "@chakra-ui/react";
import React from "react";
import { CollapsibleMenuProps } from "./interface";
import { NavLink } from "react-router-dom";

const MenuItem: React.FC<CollapsibleMenuProps> = ({ menu, level = 1 }) => {
  return (
    <Box
      sx={{
        "a, button": {
          pl: level > 1 ? `calc((${level} * 10px) + 22px)` : "10px",
          pr: "10px",
          color: level === 1 ? "#fff" : "#bee7ff",
          textDecoration: "none",
          py: "10px",
          fontSize: "14px",
          lineHeight: "1.5",
          display: "flex",
          alignItems: "center",
          fontWeight: "400",
          border: "none",
          cursor: "pointer",
          backgroundColor: "transparent",
          "&:hover": {
            textDecoration: "none",
          },
          "&.active": {
            color: "#41ddf5",
            fontWeight: "700",
          },
        },
      }}
    >
      <NavLink
        to={menu.link as string}
        className={({ isActive }) => (isActive ? "active" : "")}
      >
        <HStack w="100%">
          {menu.icon && <Box>{menu.icon}</Box>}
          <Box as="span" flex={1}>
            {menu.label}
          </Box>
        </HStack>
      </NavLink>
    </Box>
  );
};

export default MenuItem;
